// extracted by mini-css-extract-plugin
export default {"root":"_2DOo0XIe","overlapButton":"_3M8clJzy"};